import { vservice } from '@niknevis/vue-modules'
import { AdminContentCampaignRoute } from '@/modules/content-campaign/routes/admin-content-campaign.route'
import { ProfitRequest } from '@/modules/profit/models/profit-request.model'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { ManualDiscountRequestModel } from '@/modules/content-item/models/content-item-request.model'
import Dialog from 'quasar/src/plugins/Dialog.js';
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'
import {
  ContentCampaignCompletedRequestModel,
  ContentCampaignUpdateAttributesRequestModel
} from '@/modules/content-campaign/models/content-campaign-request.model'
import { BaseCampaignCancellationRequest } from '@/modules/base-campaign/models/base-campaign-request.model'

@vservice()
export class AdminContentCampaignService {
  constructor(
    private readonly routes: AdminContentCampaignRoute
  ) {
  }

  saveProfit(contentCampaignId: number, data: ProfitRequest) {
    return Inertia.post(
      this.routes.saveProfit(contentCampaignId),
      data
    )
  }

  updateCampaignManualDiscount(contentCampaignId: number, data: ManualDiscountRequestModel) {
    return Inertia.put(
      this.routes.updateCampaignManualDiscount(contentCampaignId),
      data
    )
  }

  getUpdatableAttributes(contentCampaignId: number) {
    return HTTP.get(
      this.routes.getUpdatableAttributes(contentCampaignId)
    ).then(result => result.json())
  }

  update(contentCampaignId: number, data: ContentCampaignUpdateAttributesRequestModel) {
    return Inertia.put(
      this.routes.update(contentCampaignId),
      data
    )
  }

  destroy(contentCampaignId: number) {
    return Inertia.delete(
      this.routes.destroy(contentCampaignId)
    ).onBeforeAsync(() => new Promise<boolean>((resolve) => {
      Dialog.create({
        component: DeleteConfirm,
        title: 'حذف کمپین محتوا',
        message: 'آیا از حذف کمپین محتوا اطمینان دارید ؟'
      }).onOk(() => resolve(true))
        .onCancel(() => resolve(false))
        .onDismiss(() => resolve(false))
    }))
  }

  setToCanceled(contentCampaignId: number, data: BaseCampaignCancellationRequest) {
    return Inertia.put(
      this.routes.setToCanceled(contentCampaignId),
      data
    )
  }

  completed(contentCampaignId: number, data: ContentCampaignCompletedRequestModel) {
    return Inertia.post(
      this.routes.completed(contentCampaignId),
      data
    )
  }
}